import { ErrorsTypes } from './ErrorsTypes';

export function isNotificationError(error: any): boolean {
    return error?.options?.type === ErrorsTypes.Notification;
}
